module.exports = __webpack_public_path__ + "img/18.8f832dc5.jpg";